<div class="contact">
    <kendo-avatar
      shape="circle"
      width="40"
      height="40"
      [initials]="initals()"
      [attr.aria-label]="initals()">
    </kendo-avatar>
    <div class="contact-details">
      <div class="contact-name" *ngIf="avatar.unregistrierterBenutzer == null">{{ avatar.externerBenutzer?.firstname + ' ' + avatar.externerBenutzer?.lastname}}</div>
      <div class="contact-name" *ngIf="avatar.unregistrierterBenutzer != null">{{ avatar.unregistrierterBenutzer }}</div>
      <div class="contact-email" *ngIf="avatar.unregistrierterBenutzer == null">{{ avatar.externerBenutzer?.username }}</div>
      <div class="contact-email" *ngIf="avatar.unregistrierterBenutzer != null" style="color: red" translate>{{ subtext }}</div>
    </div>
    <button *ngIf="!new && !avatar.isPrimaererExternerBenutzer" kendoButton icon="trash" (click)="removeAvatar()" [title]="'freigebendialog.user.remove' | translate"></button>
    <button *ngIf="new" kendoButton icon="add" (click)="addAvatar()" [disabled]="!vorschlagsliste && subtext != ''" translate>freigebendialog.user.add</button>
  </div>